import type { Enums } from "../types";

export { getAlertTranslationKey } from "./get-alert-translation-key";

export const ALERT_LEVEL_TYPES: Array<Enums<"alertLevelType">> = [
	"success",
	"warning",
	"danger",
	"info",
	"neutral",
];
